/**
 * Teksty na rysunkach teczki instalacji (`lib/rysunek/`).
 *
 * Dopisek w tabelce: decyzja właściciela 2026-10-23, bez nazwisk. Pola „Opracował” i „Sprawdził” zostają puste
 * do wpisania przez firmę (w czytniku PDF albo ręcznie na wydruku).
 */
export const DOPISEK_RYSUNKU = 'Opracowano w VoltValue na podstawie danych klienta. Rysunek poglądowy.'
